import React from 'react';
import {View, StyleSheet, Text } from '@react-pdf/renderer';
import OverviewBox from './OverviewBox';
import StatementTotalsBox from './StatementTotalsBox';

const styles = StyleSheet.create({
	overviewContainer: {
		flexDirection: 'row',
		// flexWrap: 'wrap',
		justifyContent: 'space-between',
		// marginTop: 24,
		borderWidth: 1,
		borderColor: '#E8E8EA',
		fontSize: 8,
		flexGrow: 1,
	},
	column: {
		flex: 1,
	},
	cell: {
		whiteSpace: "nowrap"
	}
});

const OverviewFlat = ({data, mode ='overview'}) => {
	const transposed = data[0].map((_, colIndex) => 
	  data.map(row => row[colIndex])
	);
	
	const rows = transposed.map((row, rowIndex) => { 
		//const width = Math.floor(100/row.length);
		return <View key={rowIndex} style={{...styles.column}}>
			{row.map((col, colIndex)=>{
				return <Text key={colIndex} style={{...styles.cell, fontSize: 6}}>{col?col:' '}</Text>
			})}
		</View>
	});

	return <View style={styles.overviewContainer}>{rows}</View>
};
  
export default OverviewFlat